
<!--eslint-disable-->
<!--EMISORAS-->
<template>
  <div class="crud">
    <div v-if="view == 'list'">
      <div class="column is-one-quarter level-left">
        <a class="button" @click="setForm(null)">
          <i class="fas fa-plus"></i>
        </a>
      </div>
      <div class="columns is-centered">
        <div class="table-container is-centered">
          <table class="table">
            <tr>
              <th>Icono</th>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Acción</th>
            </tr>
              <draggable v-model="list" group="people" @end="saveOrder" tag="tbody">
                <tr v-for="item in list" :key="item._key" :class="{ 'is-inactive': item.active === false }">
                  <td><img class="disk" :src="item.image" alt="" height="70" width="70"> </td>
                  <td>{{item.name}}</td>
                  <td>
                    <span v-if="item.active === false" class="tag is-warning">Inactiva</span>
                    <span v-else class="tag is-success">Activa</span>
                  </td>
                  <td>
                      <a class="button" style="margin-right: 15px" @click="setForm(item._key)">Editar</a>
                      <a class="button is-danger" @click="remove(item)">Eliminar</a>
                  </td>
                </tr>
              </draggable>
          </table>
          <p class="help">Arrastra las filas para cambiar el orden en la app. Cada emisora conserva su ID ({{ list.map(s => s.name + ': ' + s.id).join(' · ') }}), que es el que usan las estadísticas y las notificaciones por emisora.</p>
        </div>
      </div>
    </div>

    <!-- Este el formulario para agregar o editar elementos -->
    <div v-if="view == 'form'">
      <div class="column is-one-quarter level-left">
        <a  style="font-size: 24px; color: black" @click="setList">
            <i class="fas fa-arrow-left"></i>
        </a>
      </div>
      <div class="columns is-centered">
            <div class="field is-half images">
              <label for class="label">Imagen Disco Emisora</label>
              <a class="btn" @click="toggleShow(1)">
                <my-upload
                  field="img"
                  ref="uploader"
                  @crop-success="cropSuccess"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show1"
                  :width="800"
                  :height="800"
                  url="https://httpbin.org/post"
                  lang-type="es-MX"
                  :params="params"
                  :headers="headers"
                  img-format="png"
                ></my-upload>
                <img
                  style="border-radius: 50%"
                  height="150"
                  width="150"
                  :src="imgDataUrl || 'https://bulma.io/images/placeholders/256x256.png'"
                />
              </a>
            </div>
            <div class="field is-half images">
              <label for class="label">Imagen para TV (opcional)</label>
              <a class="btn" @click="toggleShow('tv')">
                <my-upload
                  field="img"
                  ref="uploaderTv"
                  @crop-success="cropSuccessTv"
                  @crop-upload-fail="cropUploadFail"
                  v-model="showTv"
                  :width="1920"
                  :height="1080"
                  url="https://httpbin.org/post"
                  lang-type="es-MX"
                  :params="params"
                  :headers="headers"
                  img-format="jpg"
                ></my-upload>
                <img
                  class="tv-preview"
                  :src="imgDataUrlTv || 'https://via.placeholder.com/320x180?text=16:9'"
                />
              </a>
              <p class="help">Fondo de pantalla completa en Apple TV y Android TV mientras suena esta emisora (16:9, 1920 × 1080). Sin imagen, la TV usa el fondo general.</p>
              <a v-if="imgDataUrlTv" class="button is-small" @click="removeTvImage">Quitar imagen para TV</a>
            </div>
              <!--
            <div class="field is-half images">
            <label for class="label">Imagen de el canal (LIGHT)</label>
              <a class="btn" @click="toggleShow(2)">
                <my-upload
                  field="img"
                  @crop-success="cropSuccess2"
                  @crop-upload-success="cropUploadSuccess2"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show2"
                  :width="410"
                  :height="103"
                  url="https://httpbin.org/post"
                  lang-type="es-MX"
                  :params="params"
                  :headers="headers"
                  img-format="png"
                ></my-upload>
                <img
                  style="background-color: #eaeaea"
                   height="1230"
                  width="309"
                  :src="imgDataUrl2 || 'https://via.placeholder.com/410x103'"
                />
              </a>

              <div>
                <label for class="label">Imagen de el canal (DARK)</label>
              <a class="btn" @click="toggleShow(3)">
                <my-upload
                  field="img"
                  @crop-success="cropSuccess3"
                  @crop-upload-success="cropUploadSuccess3"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show3"
                  :width="410"
                  :height="103"
                  url="https://httpbin.org/post"
                  lang-type="es-MX"
                  :params="params"
                  :headers="headers"
                  img-format="png"
                ></my-upload>
                <img
                  style="background-color: #eaeaea"
                  height="1230"
                  width="309"
                  :src="imgDataUrl3 || 'https://via.placeholder.com/410x103'"
                />
              </a>
              </div>
            </div>
-->
          </div>

          <div style="width:50vw; margin: auto">
            <div class="field">
              <label for="tema" class="label" >Nombre Emisora</label>
              <input v-model="form.name" class="input width-full" type="text" placeholder="Nombre" />
            </div>
            <div class="field">
              <label for="tema" class="label">Url Emisora</label>
              <input v-model="form.url" class="input width-full" type="text" placeholder="Url" />
            </div>
            <div class="field">
              <label for="tema" class="label">Url Streaming</label>
              <input v-model="form.urlStreaming" class="input width-full" type="text" placeholder="Url" />
            </div>
            <div class="field">
              <label class="checkbox">
                <input v-model="form.active" type="checkbox" />
                Emisora activa (visible en la app)
              </label>
              <p class="help">Desmárcala para ocultarla temporalmente (por ejemplo, si el stream está caído) sin perder su configuración. Las versiones anteriores de la app (1.80 y anteriores) la siguen mostrando.</p>
            </div>
            <div class="field">
                  <a class="button width-full" :disabled="uploading > 0" @click="save">{{ uploading > 0 ? 'Subiendo imagen…' : 'Guardar' }}</a>
            </div>
          </div>

       </div>
    </div>

</template>
<script>
/* eslint-disable */
import HelloWorld from "@/components/HelloWorld.vue";
import myUpload from "vue-image-crop-upload";
import { setTimeout } from "timers";
import {db, storageRef} from "../../services/firebase-init";
import { ToastProgrammatic as Toast } from 'buefy'
export default {
  name: "crud",
  components: {
    HelloWorld,
    myUpload,
  },
  data() {
    return {
      imgDataUrl: "", // the datebase64 url of created image
      imgDataUrl2: "", // the datebase64 url of created image
      imgDataUrl3: "",
      imgDataUrlTv: "",
      view: "list",
      // Firebase key of the station being edited (null when adding a new one).
      editKey: null,
      show1: false,
      show2: false,
      show3: false,
      showTv: false,
      uploading: 0,
      list: [],
      form: {},
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
    };
  },
  created() {
    this.stationsRef = db.ref("/form/stations");
    db.ref("/form/styles").on("value", snapshot => {
      const obj = snapshot.val() || {};
      this.theme = obj['theme'];
    });

    // Keys are positions (1, 2, 3…), which is the order the apps show. The station ID is
    // the "id" field and never changes: statistics and push topics (emisora_<id>) use it.
    this.stationsRef.on("value", snapshot => {
      const obj = snapshot.val() || {};
      const keys = Object.keys(obj).filter(key => obj[key]);
      const missingIds = {};
      this.list = keys.map(key => {
        const station = Object.assign({}, obj[key]);
        if (station.id === undefined || station.id === null || station.id === '') {
          station.id = key;
          missingIds[key + '/id'] = key;
        }
        station.id = String(station.id);
        station._key = key;
        return station;
      });
      if (Object.keys(missingIds).length) this.stationsRef.update(missingIds);
    });
  },
  beforeDestroy() {
    this.stationsRef.off();
  },
  methods: {
    setForm(key) {
      this.editKey = key;
      this.view = "form";
      this.imgDataUrl2 = '';
      this.imgDataUrl3 = '';
      if (!key) {
        this.form = { active: true };
        this.imgDataUrl = '';
        this.imgDataUrlTv = '';
        return;
      }
      this.stationsRef.child(key).once('value', snapshot => {
        const station = snapshot.val() || {};
        this.form = Object.assign({}, station, { active: station.active !== false });
        this.imgDataUrl = station.image || '';
        this.imgDataUrlTv = station.imageTv || '';
      });
    },
    setList() {
      this.view = "list";
    },
    requiredFields(){
      return Toast.open({
        duration: 5000,
        message: 'Faltan el nombre, la URL de la emisora o la imagen del disco',
        position: 'is-top',
        type: 'is-danger'
      })
    },
    sucessMessage(message){
      return Toast.open({
        duration: 5000,
        message: message,
        position: 'is-top',
        type: 'is-success'
      })
    },
    errorMessage(error){
      return Toast.open({
        duration: 8000,
        message: 'No se pudo guardar: ' + (error && error.message ? error.message : error),
        position: 'is-top',
        type: 'is-danger'
      })
    },
    // Fields written to Firebase; empty optional fields are removed (null).
    stationPayload() {
      const text = value => (typeof value === 'string' ? value.trim() : '');
      return {
        name: text(this.form.name),
        url: text(this.form.url),
        urlStreaming: text(this.form.urlStreaming) || null,
        image: this.form.image,
        imageTv: this.form.imageTv || null,
        active: this.form.active !== false,
      };
    },
    save() {
      if (this.uploading > 0) return;
      const payload = this.stationPayload();
      if (!payload.name || !payload.url || !payload.image) return this.requiredFields();
      const done = () => {
        this.setList();
        this.sucessMessage('Se guardó exitosamente');
      };
      if (this.editKey) {
        this.stationsRef.child(this.editKey).update(payload).then(done, this.errorMessage);
        return;
      }
      const numeric = values => values.map(Number).filter(n => Number.isInteger(n) && n > 0);
      const nextId = Math.max(0, ...numeric(this.list.map(s => s.id))) + 1;
      const nextKey = Math.max(0, ...numeric(this.list.map(s => s._key))) + 1;
      payload.id = String(nextId);
      this.stationsRef.child(String(nextKey)).set(payload).then(done, this.errorMessage);
    },
    // Rewrites the list with keys 1..N in the current order, keeping each station's id.
    saveOrder() {
      const obj = {};
      this.list.forEach((station, index) => {
        const copy = Object.assign({}, station);
        delete copy._key;
        obj[String(index + 1)] = copy;
      });
      return this.stationsRef.set(obj).catch(this.errorMessage);
    },
    remove(station){
      if (!confirm('¿Eliminar la emisora ' + station.name + '? Si solo quieres ocultarla, edítala y desmarca "Emisora activa".')) return;
      this.list = this.list.filter(item => item._key !== station._key);
      this.saveOrder();
    },
    toggleShow(num) {
      if(num == 1)
      this.show1 = !this.show1;
      if(num == 2)
      this.show2 = !this.show2;
      if(num == 3)
      this.show3 = !this.show3;
      if(num == 'tv')
      this.showTv = !this.showTv;
    },
    uploadImage(imgDataUrl, field) {
      this.uploading += 1;
      const re = storageRef.child(String(Date.now()));
      re.putString(imgDataUrl, 'data_url')
        .then(() => re.getDownloadURL())
        .then(downloadURL => this.$set(this.form, field, downloadURL))
        .catch(this.errorMessage)
        .then(() => { this.uploading -= 1; });
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      this.uploadImage(imgDataUrl, 'image');
      this.imgDataUrl = imgDataUrl;
      setTimeout(()=> this.$refs.uploader.setStep(1), 3000)
    },
    cropSuccessTv(imgDataUrl, field) {
      this.uploadImage(imgDataUrl, 'imageTv');
      this.imgDataUrlTv = imgDataUrl;
      setTimeout(()=> this.$refs.uploaderTv.setStep(1), 3000)
    },
    removeTvImage() {
      this.$set(this.form, 'imageTv', '');
      this.imgDataUrlTv = '';
    },
      cropSuccess2(imgDataUrl, field) {
      var re = storageRef.child(String(Date.now()))
      re.putString(imgDataUrl, 'data_url').then(()=> {
        re.getDownloadURL().then((downloadURL) => {
           if(!this.form[this.theme]) this.form[this.theme]= {}
           this.form[this.theme]['image2'] = downloadURL;
      });
  });
      this.imgDataUrl2 = imgDataUrl;
       this.$refs.uploader.setStep(2)
    },
    cropSuccess3(imgDataUrl, field) {
      var re = storageRef.child(String(Date.now()))
      re.putString(imgDataUrl, 'data_url').then(()=> {
        re.getDownloadURL().then((downloadURL) => {
           this.form[this.theme]['image3'] = downloadURL;
      });
  });
      this.imgDataUrl3 = imgDataUrl;
       this.$refs.uploader.setStep(2)
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {

      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
      cropUploadSuccess2(jsonData, field) {

      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
      cropUploadSuccess3(jsonData, field) {

      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    base64toBlob (b64Data, sliceSize) {
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: "image/jpeg"});
    return blob;
  }

  }
};
</script>

<style scoped>
  .disk{
    border-radius: 50%;
  }
  .images{
    margin: 0 80px
  }
  .is-inactive td {
    opacity: 0.5;
  }
  .tv-preview {
    width: 320px;
    height: 180px;
    object-fit: cover;
    background-color: #eaeaea;
  }
</style>
